import z from 'zod';
import { SOURCE_PLATFORM_TYPE } from '../public-filter';

export const savedCreatorListSchema = z.object({
  id: z.string(),
  title: z.string(),
  total_count: z.number(),
  created_at: z.string(),
});

export const creatorsInListSchema = z.object({
  id: z.string(),
  platform: z.enum(SOURCE_PLATFORM_TYPE),
  username: z.string(),
  nickname: z.string(),
  profile_url: z.string(),
  profile_image_url: z.string(),
  bio: z.string(),
  followers: z.number(),
  recent_avg_er: z.number(),
  post_categories: z.array(z.string()),
  excluded_at: z.string().optional(),
  demographics: z
    .object({
      age: z.array(z.string()),
      gender: z.array(z.string()),
      race: z.array(z.string()),
      location: z.array(z.string()),
      language: z.array(z.string()),
    })
    .optional(),
});

export const creatorsListSchema = z.object({
  creators: z.array(creatorsInListSchema),
  page: z.number(),
  total_pages: z.number(),
  total_count: z.number(),
});

export const creatorsListRequestSchema = z.union([
  z.object({
    page: z.number().min(1).optional(),
    limit: z.number().min(1).max(100).default(20).optional(),
  }),
  z.null(),
]);

export const addCreatorsSchema = z.union([
  z.object({
    search_id: z.string(),
    selected_all: z.boolean(),
  }),
  z.object({
    search_id: z.string(),
    creator_ids: z.array(z.string()),
  }),
]);

export const removeCreatorsSchema = z.union([
  z.object({
    search_id: z.string(),
    selected_all: z.boolean(),
  }),
  z.object({
    creator_ids: z.array(z.string()),
  }),
]);
